import { render, staticRenderFns } from "./universal_search.vue?vue&type=template&id=7e25f845&scoped=true&"
import script from "./universal_search.vue?vue&type=script&lang=js&"
export * from "./universal_search.vue?vue&type=script&lang=js&"
import style0 from "./universal_search.vue?vue&type=style&index=0&id=7e25f845&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e25f845",
  null
  
)

export default component.exports